import { useTranslation } from "react-i18next";

import type { LockReason, Staff } from "@/lib/auth";

import { PinScreen } from "./PinScreen";

/**
 * Lock over the current screen (T07-22): 3 min without a touch, an expired staff token, or
 * 「交代」 — the screen under it (the basket) stays as it was and comes back after the PIN.
 */
export function LockScreen({ reason, lastStaff }: { reason: LockReason; lastStaff: Staff | null }) {
  const { t } = useTranslation();
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label={t("app.lock")}
      className="fixed inset-0 z-50 bg-background"
    >
      <PinScreen reason={reason} lastStaff={lastStaff} />
    </div>
  );
}
